import { useEffect, useState } from "react";

/**
 * True only once `loading` has stayed true for longer than `delay` ms, so
 * fast responses never flash a skeleton. Drops back to false immediately.
 */
export function useDelayedLoading(loading, delay = 200) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShow(false);
      return undefined;
    }
    const t = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(t);
  }, [loading, delay]);

  return loading && show;
}

export default useDelayedLoading;
